module.exports = __webpack_public_path__ + "img/notice.bc81686d.png";